import { render, staticRenderFns } from "./HighlightingLabel.vue?vue&type=template&id=43f11e0f&"
import script from "./HighlightingLabel.vue?vue&type=script&lang=js&"
export * from "./HighlightingLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports